const PATH = process.env.PUBLIC_URL;

export const images = {
    // 상품 목록
    ipad: PATH + '/assets/images/presentList/ipad.png',
    sony: PATH + '/assets/images/presentList/sony.png',
    appleWatch: PATH + '/assets/images/presentList/appleWatch.png',
    // 흥이 HOLA
    gold: PATH + '/assets/images/funHola/001.png',
    silver: PATH + '/assets/images/funHola/002.png',
    bronze: PATH + '/assets/images/funHola/003.png',
    goldCard: PATH + '/assets/images/funHola/goldCard.png',
    bisang: PATH + '/assets/images/funHola/bisang.png',
    
    // 달아 HOLA 동아리
    blackheart: PATH + '/assets/images/hotHola/blackheart.png',
    music: PATH + '/assets/images/hotHola/music.png',
    pegasuss: PATH + '/assets/images/hotHola/pegasuss.png',
    // main song
    album: PATH + '/assets/images/mainSong/song.png',
    
    // snsEvent
    sns1: PATH + '/assets/images/snsEvent/001.png',
    sns2: PATH + '/assets/images/snsEvent/002.png',
    // timetable
    line: PATH + '/assets/images/line.png',
    // Secret Guest
    guest1: PATH + '/assets/images/guest/guest1.png',
    guest2: PATH + '/assets/images/guest/guest2.png',

    // About LOGO
    likelionLogo: PATH + '/assets/images/about/likelion/likelionLogo.png',
    councilLogo: PATH + '/assets/images/about/studentCouncil/총학생회로고.png',
    
    // 미모티콘
    cz : PATH + '/assets/images/about/likelion/cz.png',
    minji : PATH + '/assets/images/about/likelion/minji.png',
    seunghee : PATH + '/assets/images/about/likelion/seunghee.png',
    hojoo: PATH + '/assets/images/about/likelion/hojoo.png',

    // Navlogo
    Navlogo : PATH + '/assets/images/boomCloudLogo.png',
};